import ApiClient from "@thrivecoin/adapter";

export const thcApi = new ApiClient({ baseUrl: import.meta.env.VITE_API_BASE_URL });
